import axios from 'axios';

export default function postCreditTransfer(payload) {
  console.log('postCreditTransfer payload:', payload);
  return new Promise((resolve, reject) => axios
    .post('/account/system-admin/api/v1/company/user/credit-transfer', payload)
    .then((response) => resolve(response))
    .catch((error) => reject(error.message)));
}
